import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import ArabicKeyboardPopup from "./keyboardpopup";
import { FaKeyboard } from "react-icons/fa";
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import LeaseApiService from '../../services/apiService';

const PersonalDetails = ({ tableLoading, nationalityList, setPhoneCountry, phoneCountry, setSelectedCity, handleCountryChange, countriesList, cityList, setTransectionData, titleList, packageName, categoryMix, transectionData, leadType, agentList, selectedCountry, selectedCity, sourceList, customerTypeList, salesPersonList, leadStatus, defaultCountry }) => {

    const apiService = new LeaseApiService();
    const [activeField, setActiveField] = useState(null);
    const [subSourceList, setSubSourceList] = useState([]);
    const currentCountry = dialCodeToCountryMap[transectionData?.Exp6] || defaultCountry;
    const phoneValue = transectionData?.Exp6 && transectionData?.mobileNo ? `${transectionData.Exp6.replace('+', '')}${transectionData.mobileNo}` : '';
    const genderOptions = [
        { value: "M", label: "Male" },
        { value: "F", label: "Female" },
        { value: "O", label: "Other" },
    ];
    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            if (name === "firstName" || name === "lastName") {
                updatedData.fullName = `${updatedData.firstName || ""} ${updatedData.lastName || ""}`.trim();
            }
            return updatedData;
        });
    };
    const handleDropDownChange = async ({ name, value }) => {
        if (name === "source") {
            setTransectionData(prev => ({ ...prev, [name]: value }));
            const params = new URLSearchParams();
            params.append('DropdownFor', 'CustSubSource');
            params.append('CascadText', value?.label);
            const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
            setSubSourceList(res?.data?.items)
        } else {
            setTransectionData(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
    }
    const handleKeyboardChange = (value) => {
        setTransectionData(prev => ({
            ...prev,
            [activeField]: value
        }));
    };
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                <div className="form-group grid-contain ">
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Type *</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData.type}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
                            options={customerTypeList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No *</label> :
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Mobile No *</label>
                        }
                        <div style={{ width: '100%' }}>
                            <PhoneInput
                                country={defaultCountry}          // initial only — never recompute this per render
                                value={transectionData?.fullPhone || ''}   // the raw value, NOT a rebuilt one
                                onChange={(value, country) => {
                                    const dialCode = country?.dialCode || '';
                                    setTransectionData(prev => ({
                                        ...prev,
                                        fullPhone: value,             // store exactly what the lib gives back
                                        Exp6: `+${dialCode}`,
                                        mobileNo: value.slice(dialCode.length),
                                        countryCode: country,
                                    }));
                                }}
                                enableSearch
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Agent</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData.agent}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'agent', value: selectedOption })}
                            options={agentList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Title *</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData.title}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'title', value: selectedOption })}
                            options={titleList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Email ID *</label>
                        <input type="email" className="p-2 form-control w-75" value={transectionData?.email} onChange={handleInputChange} name="email" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Lead Type</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.leadtype}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'leadtype', value: selectedOption })}
                            options={leadType?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Company</label> :
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">First Name</label>
                        }
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.firstName} onChange={handleInputChange} name="firstName" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Gender *</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.gender}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'gender', value: selectedOption })}
                            options={genderOptions?.map(country => ({ value: country, label: country?.label }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Country</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={selectedCountry}
                            onChange={handleCountryChange}
                            options={countriesList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                        <div></div> : <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Last Name</label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.lastName} onChange={handleInputChange} name="lastName" />
                        </div>
                    }
                    <div className="d-flex">
                        {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Rep Phone No </label> :
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Phone No </label>
                        }
                        <div style={{ width: '75%' }}>
                            <PhoneInput className="p-0"
                                country={currentCountry}
                                value={transectionData.phoneNo}
                                onChange={(value, country) => {
                                    setTransectionData(prev => ({
                                        ...prev,
                                        phoneNo: value,
                                        countryCode: country,
                                    }));
                                }}
                                enableSearch
                            />
                        </div>
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom22" className="form-label">City</label>
                        <Select className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={selectedCity}
                            onChange={handleCityChange}
                            options={cityList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                        <div></div> : <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Full Name *</label>
                            <input type="text" className="p-2 form-control w-75" value={`${transectionData?.fullName || ""}`}
                                readOnly name="stayedPeriod" />
                        </div>
                    }
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">P.O.Box </label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.poBox} onChange={handleInputChange} name="poBox" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Nationality *</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.nationality}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'nationality', value: selectedOption })}
                            options={nationalityList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Source </label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.source}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'source', value: selectedOption })}
                            options={sourceList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Subsource </label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.subsource}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'subsource', value: selectedOption })}
                            options={subSourceList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Sales Person *</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.salesPerson}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'salesPerson', value: selectedOption })}
                            options={salesPersonList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Package</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={transectionData?.productType}
                            onChange={(selectedOption) => handleDropDownChange({ name: 'productType', value: selectedOption })}
                            options={packageName?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                        <div></div> : <div className="d-flex">
                            <label htmlFor="validationCustom01" className="form-label pt-1 start">Company Name </label>
                            <input type="text" className="p-2 form-control w-75" value={transectionData?.companyName} onChange={handleInputChange} name="companyName" />
                        </div>
                    }
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Designation </label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.designation} onChange={handleInputChange} name="designation" />
                    </div>
                    {/* <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Date of Birth *</label>
                        <DatePicker
                            todayButton="Today"
                            selected={transectionData?.dateofBirth}
                            onChange={(date) => handleDateChange({ name: 'dateofBirth', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div> */}

                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Address </label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.address} onChange={handleInputChange} name="address" />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Address 2</label>
                        <input type="text" className="p-2 form-control w-75" value={transectionData?.address2} onChange={handleInputChange} name="address2" />
                    </div>
                    <div></div>
                    <div className="d-flex align-items-center">
                        {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                            <label className="form-label w-25">CO. Name (AR)</label> :
                            <label className="form-label w-25">FirstName (AR)</label>
                        }
                        <input
                            type="text"
                            dir="rtl"
                            lang="ar"
                            className="form-control"
                            value={transectionData.firstNameAR}
                            onChange={(e) =>
                                setTransectionData(prev => ({
                                    ...prev,
                                    firstNameAR: e.target.value
                                }))
                            }
                            onFocus={() => setActiveField("firstNameAR")}
                        />


                        <FaKeyboard size={30}
                            className="ms-2 keyboard-icon"
                            onClick={() => setActiveField("firstNameAR")}
                        />
                    </div>
                    {/* Last Name AR */}

                    {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                        <div></div> :
                        <div className="d-flex align-items-center mt-3">
                            <label className="form-label w-25">LastName (AR)</label>

                            <input
                                type="text"
                                className="form-control"
                                dir="rtl"
                                lang="ar"
                                value={transectionData.lastNameAR}
                                onChange={(e) =>
                                    setTransectionData(prev => ({
                                        ...prev,
                                        lastNameAR: e.target.value
                                    }))
                                }
                                onFocus={() => setActiveField("lastNameAR")}
                            />

                            <FaKeyboard size={30}
                                className="ms-2 keyboard-icon"
                                onClick={() => setActiveField("lastNameAR")}
                            />
                        </div>
                    }
                    {/* Address AR */}
                    <div className="d-flex align-items-center mt-3">
                        <label className="form-label w-25">Address (AR)</label>

                        <input
                            type="text"
                            className="form-control"
                            dir="rtl"
                            lang="ar"
                            value={transectionData.addressAR}
                            onChange={(e) =>
                                setTransectionData(prev => ({
                                    ...prev,
                                    addressAR: e.target.value
                                }))
                            }
                            onFocus={() => setActiveField("addressAR")}
                        />
                        <FaKeyboard size={30}
                            className="ms-2 keyboard-icon"
                            onClick={() => setActiveField("addressAR")}
                        />
                    </div>
                    {/* Keyboard Popup */}
                    {activeField && (
                        <ArabicKeyboardPopup
                            value={transectionData[activeField]}
                            setValue={handleKeyboardChange}
                            onClose={() => setActiveField(null)}
                        />
                    )}
                </div>
            </div>
        </div >
    );
};
export default PersonalDetails;
export const dialCodeToCountryMap = {
    '+1': 'us',
    '+7': 'ru',
    '+20': 'eg',
    '+27': 'za',
    '+30': 'gr',
    '+31': 'nl',
    '+32': 'be',
    '+33': 'fr',
    '+34': 'es',
    '+36': 'hu',
    '+39': 'it',
    '+40': 'ro',
    '+41': 'ch',
    '+43': 'at',
    '+44': 'gb',
    '+45': 'dk',
    '+46': 'se',
    '+47': 'no',
    '+48': 'pl',
    '+49': 'de',
    '+51': 'pe',
    '+52': 'mx',
    '+53': 'cu',
    '+54': 'ar',
    '+55': 'br',
    '+56': 'cl',
    '+57': 'co',
    '+58': 've',
    '+60': 'my',
    '+61': 'au',
    '+62': 'id',
    '+63': 'ph',
    '+64': 'nz',
    '+65': 'sg',
    '+66': 'th',
    '+81': 'jp',
    '+82': 'kr',
    '+84': 'vn',
    '+86': 'cn',
    '+90': 'tr',
    '+91': 'in',
    '+92': 'pk',
    '+93': 'af',
    '+94': 'lk',
    '+95': 'mm',
    '+98': 'ir',
    '+211': 'ss',
    '+212': 'ma',
    '+213': 'dz',
    '+216': 'tn',
    '+218': 'ly',
    '+220': 'gm',
    '+221': 'sn',
    '+222': 'mr',
    '+223': 'ml',
    '+224': 'gn',
    '+225': 'ci',
    '+226': 'bf',
    '+227': 'ne',
    '+228': 'tg',
    '+229': 'bj',
    '+230': 'mu',
    '+231': 'lr',
    '+232': 'sl',
    '+233': 'gh',
    '+234': 'ng',
    '+235': 'td',
    '+236': 'cf',
    '+237': 'cm',
    '+238': 'cv',
    '+239': 'st',
    '+240': 'gq',
    '+241': 'ga',
    '+242': 'cg',
    '+243': 'cd',
    '+244': 'ao',
    '+245': 'gw',
    '+246': 'io',
    '+248': 'sc',
    '+249': 'sd',
    '+250': 'rw',
    '+251': 'et',
    '+252': 'so',
    '+253': 'dj',
    '+254': 'ke',
    '+255': 'tz',
    '+256': 'ug',
    '+257': 'bi',
    '+258': 'mz',
    '+260': 'zm',
    '+261': 'mg',
    '+262': 're',
    '+263': 'zw',
    '+264': 'na',
    '+265': 'mw',
    '+266': 'ls',
    '+267': 'bw',
    '+268': 'sz',
    '+269': 'km',
    '+290': 'sh',
    '+291': 'er',
    '+297': 'aw',
    '+298': 'fo',
    '+299': 'gl',
    '+350': 'gi',
    '+351': 'pt',
    '+352': 'lu',
    '+353': 'ie',
    '+354': 'is',
    '+355': 'al',
    '+356': 'mt',
    '+357': 'cy',
    '+358': 'fi',
    '+359': 'bg',
    '+370': 'lt',
    '+371': 'lv',
    '+372': 'ee',
    '+373': 'md',
    '+374': 'am',
    '+375': 'by',
    '+376': 'ad',
    '+377': 'mc',
    '+378': 'sm',
    '+380': 'ua',
    '+381': 'rs',
    '+382': 'me',
    '+383': 'xk',
    '+385': 'hr',
    '+386': 'si',
    '+387': 'ba',
    '+389': 'mk',
    '+420': 'cz',
    '+421': 'sk',
    '+423': 'li',
    '+852': 'hk',
    '+853': 'mo',
    '+855': 'kh',
    '+856': 'la',
    '+880': 'bd',
    '+886': 'tw',
    '+960': 'mv',
    '+961': 'lb',
    '+962': 'jo',
    '+963': 'sy',
    '+964': 'iq',
    '+965': 'kw',
    '+966': 'sa',
    '+967': 'ye',
    '+968': 'om',
    '+970': 'ps',
    '+971': 'ae',
    '+972': 'il',
    '+973': 'bh',
    '+974': 'qa',
    '+975': 'bt',
    '+976': 'mn',
    '+977': 'np',
    '+992': 'tj',
    '+993': 'tm',
    '+994': 'az',
    '+995': 'ge',
    '+996': 'kg',
    '+998': 'uz'
};